import type { AppointmentType } from '@bb/domain/dist/types';
import { featureEnabled } from './featureFlagBrowserClient';

const correctShowingTypeLabel = (
  type:
    | AppointmentType
    | 'APPOINTMENT'
    | 'ROUTE_STOP'
    | 'Information Request'
    | 'MANAGED_ACCESS',
) => {
  if (!featureEnabled('agentInspectionRelabelFeature')) return type;
  switch (type) {
    case 'Agent Inspection':
      return 'Agent Inspection/Preview';
    case 'MANAGED_ACCESS':
      return 'Managed Access';
    default:
      return type;
  }
};

export default correctShowingTypeLabel;
